import { useQuery } from "@tanstack/react-query";
import fetcher from "src/utils/fetcher";
import { useAuth } from "src/components/utils/auth/assist/authContext";

export interface InkedSendCountsParams {
  product: string;
  ids: (number | string)[];
}

export interface ListingSendCounts {
  count: number;
  cards: unknown[]; // We don't use the cards array, just the count
}

export interface InkedSendCountsResponse {
  [listingId: string]: ListingSendCounts;
}

export const useInkedSendCounts = (params?: InkedSendCountsParams) => {
  const { user } = useAuth();
  const { product, ids } = params || {};

  return useQuery({
    queryKey: ["inkedSendCounts", product, ids],
    queryFn: async (): Promise<InkedSendCountsResponse> => {
      const response = await fetcher({
        url: `/api/inked/sends`,
        method: 'POST',
        body: {
          product,
          ids,
        },
      });

      return response.data as InkedSendCountsResponse;
    },
    enabled: !!user && !!product && !!ids && ids.length > 0,
    staleTime: 60000, // Cache for 1 minute
    refetchOnMount: false,
    refetchOnWindowFocus: false,
  });
};
